import { Component, Input, OnInit } from '@angular/core';
import { Combobox, NotificationService } from 'pmv-common';
import { RouteNavigationService } from '../../../services/api/route-navigation.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { AccountService } from '../../../services/account.service';
import { DadosPessoa } from '../../../models/account/dados-pessoa.model';
import { AlterarSenhaPessoa } from '../../../models/account/alterar-senha-pessoa.model';
import { PerguntaAleatoria } from '../../../models/account/pergunta-aleatoria.model';

@Component({
    selector: 'pmv-login-recuperar-senha',
    templateUrl: './recuperar-senha.component.html'
})

export class RecuperarSenhaComponent implements OnInit {

    loading: Boolean = false;
    mostrarCPFNascimento: Boolean = true;
    mostrarNovaSenhaHeConfirmacao: Boolean = false;
    mostrarPerguntaAleatoria: Boolean = false;
    cpf: string;
    dataDeNascimento: Date;
    perguntaOptions: Combobox[];
    pergunta: string;
    idPergunta: number;

    perguntaAleatoria: PerguntaAleatoria;
    novaSenha: string;
    confirmaNovaSenha: string;

    constructor(private accountService: AccountService,
        private routeDataService: RouteNavigationService,
        private readonly notificationService: NotificationService) {
    }

    validarPessoa(): void {

        if (this.cpf === undefined) {
            return this.notificationService.notifyError('Por favor informe um CPF válido.');
        }
        if (this.cpf.length < 11) {
            return this.notificationService.notifyError('Por favor informe um CPF válido.');
        }
        if (this.dataDeNascimento === undefined) {
            return this.notificationService.notifyError('Por favor informe Data de Nascimento válida.');
        }

        this.cpf = this.retirarFormatacao(this.cpf);
        return this.confirmarDadosPessoa();


    }

    confirmarDadosPessoa(): void {
        this.loading = true;
        var dadosPessoa = new DadosPessoa();
        dadosPessoa.cpf = this.cpf;
        dadosPessoa.nascimento = this.dataDeNascimento;
        forkJoin(
            this.accountService.ConfirmarDadosPessoa(dadosPessoa),
        ).subscribe(resp => {
            this.mostrarCPFNascimento = false;
            this.mostrarPerguntaAleatoria = true;
            this.perguntaAleatoria = resp[0];
            this.carregarPergunta();
        }, error => {
            this.loading = false;
            throw this.notificationService.notifyError(error.error.erro);
        });
        this.loading = false;
    }

    retirarFormatacao(valor) {
        return valor.replace(/(\.|\/|\-)/g, "");
    }

    alterarSenha(): void {
        if (this.novaSenha === undefined) {
            return this.notificationService.notifyError('Por favor preencha o campo senha.');
        }
        if (this.novaSenha.length < 6) {
            return this.notificationService.notifyError('A senha nova precisa ter no mínimo 6 dígitos.');
        }
        if (this.confirmaNovaSenha === undefined) {
            return this.notificationService.notifyError('Por favor repita a nova senha no campo de confirmação de senha.');
        }
        if (this.novaSenha !== this.confirmaNovaSenha) {
            return this.notificationService.notifyError('A confirmação de nova senha precisa ter no mínimo 6 dígitos.');
        }

        this.loading = true;
        var alterarSenha = new AlterarSenhaPessoa();
        alterarSenha.novaSenha = this.novaSenha;
        alterarSenha.confirmaNovaSenha = this.confirmaNovaSenha;

        var dadosPessoa = new DadosPessoa();
        dadosPessoa.cpf = this.cpf;
        dadosPessoa.nascimento = this.dataDeNascimento;
        alterarSenha.dadosPessoa = dadosPessoa;

        forkJoin(
            this.accountService.AlterarSenhaPessoa(alterarSenha)
        ).subscribe(resp => {
            this.loading = false;
            this.routeDataService.fromRecuperarSenhaToLogin("Senha alterada com sucesso!");

        }, error => {
            this.loading = false;
            throw this.notificationService.notifyError(error.error.erro);
        });
    }

    carregarPergunta(): void {
        this.pergunta = this.perguntaAleatoria.pergunta;
        this.idPergunta = this.perguntaAleatoria.idPergunta;

        let listaRespostas = [];
        this.perguntaAleatoria.respostas.forEach(resp => {
            const respotaopt = { id: 1, descricao: resp };
            listaRespostas.push(respotaopt);
        });

        this.perguntaOptions = listaRespostas;
    }

    validarResposta(): void {
        let respostaCorreta = {
            cpf: this.cpf,
            id: this.idPergunta,
            resposta: this.perguntaAleatoria.resposta
        }

        forkJoin(
            this.accountService.ValidarRespostaPerguntaAleatoria(respostaCorreta),
        ).subscribe(resp => {
            this.mostrarCPFNascimento = false;
            this.mostrarPerguntaAleatoria = false;
            this.mostrarNovaSenhaHeConfirmacao = true;

        }, error => {
            this.loading = false;
            throw this.notificationService.notifyError(error.error.erro);
        });
    }

    ngOnInit(): void { }
}


// WEBPACK FOOTER //
// ./src/app/pages/login/senha/recuperar-senha.component.ts